/**
 * @desc 分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.productSizeSection.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/ProductSizeSection/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
